import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

import DocumentoImpuestosTrasladosManager from './DocumentoImpuestosTrasladosManager';
import DocumentoImpuestosRetencionesManager from './DocumentoImpuestosRetencionesManager';

const DocumentoRelacionadoImpuestos = (props) => {

  const { data } = props;

  const { ImpuestosDR } = data;

  const [show, setShow] = useState({
    traslados: !!ImpuestosDR?.TrasladosDR,
    retenciones: !!ImpuestosDR?.RetencionesDR
  });

  useEffect(() => {
    setShow({
      traslados: !!ImpuestosDR?.TrasladosDR,
      retenciones: !!ImpuestosDR?.RetencionesDR
    })
  }, [data.ObjetoImpDR, ImpuestosDR?.TrasladosDR, ImpuestosDR?.RetencionesDR]); // eslint-disable-line

  const handleOnChange = (impuestos) => {
    props.onChange(impuestos);
  }

  const handleOnImpuestosCheckboxChange = (event) => {
    const { name, checked } = event.target;

    if (!checked) {
      const newData = {
        ...ImpuestosDR,
        TrasladosDR: name === 'traslados' ? undefined : ImpuestosDR?.TrasladosDR,
        RetencionesDR: name === 'retenciones' ? undefined : ImpuestosDR?.RetencionesDR,
      }

      props.onChange(newData)
    }

    setShow({
      ...show,
      [name]: checked
    });
  }

  const desglose = data.ObjetoImpDR !== '01';

  return (
    <>
      { desglose && (
        <>
          <Form.Group controlId="traslados">
            <Form.Check type="checkbox"
              name="traslados"
              label="Incluir Traslados"
              checked={ show.traslados || false }
              onChange={ handleOnImpuestosCheckboxChange }
            />
          </Form.Group>

          { show.traslados &&
            <DocumentoImpuestosTrasladosManager
              data={ data }
              onChange={ handleOnChange }
            />
          }

          <Form.Group controlId="retenciones">
            <Form.Check type="checkbox"
              name="retenciones"
              label="Incluir Retenciones"
              checked={ show.retenciones || false }
              onChange={ handleOnImpuestosCheckboxChange }
            />
          </Form.Group>

          { show.retenciones &&
            <DocumentoImpuestosRetencionesManager
              data={ data }
              onChange={ handleOnChange }
            />
          }
        </>
      )}
    </>
  );
}


export default DocumentoRelacionadoImpuestos;
